import React, { useState, useEffect } from 'react';
import TR from './../../Trans';
import 'video.js/dist/video-js.css';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ContentContainer from './../items/ContentContainer';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import MenuItem from '@mui/material/MenuItem';
import List from '@mui/material/List';
import Waiting from './../items/Waiting';
import TrackListContainer from './../items/TrackListContainer';
import Menu from '@mui/material/Menu';
import TrackListScroller from './../items/TrackListScroller';
import Confirm from '../dialogs/Confirm';
import Button from '@mui/material/Button';
import SearchFilters from './../items/SearchFilters';
import SaveBackgroundMusicFilter from '../dialogs/SaveBackgroundMusicFilter';
import IconButton from '@mui/material/IconButton';
import DeleteDialog from '../dialogs/DeleteDialog';
import bgStylesStore from '../../stores/bgStyles';
import sessionStore from './../../stores/session';
import environmentStore from './../../stores/environment';
import { decades } from '../../common/decades';
import navigationStore from '../../stores/navigation';
import musicStore from '../../stores/music';
import singersStore from '../../stores/singers';
import bgFiltersStore from '../../stores/bgFilters';
import messageStore from '../../stores/message';
import bgPerformanceStore from '../../stores/bgPerformance';
import settingsStore from '../../stores/settings';

function BgStyles() {

  const itemsOnPage = 25;
  const toggleMusicSearchFilters = navigationStore((state) => state.toggleMusicSearchFilters);
  const isWaiting = bgStylesStore((state) => state.isWaiting);
  const sessionToken = sessionStore((state) => state.sessionToken);
  const isEnvironmentSet = environmentStore((state) => state.isEnvironmentSet);
  const getEnvironment = environmentStore((state) => state.getEnvironment);
  const environment = environmentStore((state) => state.environment);
  const filterLanguages = bgStylesStore((state) => state.filterLanguages);
  const setLanguageFilter = bgStylesStore((state) => state.setLanguageFilter);
  const filterGenres = bgStylesStore((state) => state.filterGenres);
  const setGenreFilter = bgStylesStore((state) => state.setGenreFilter);
  const emptyPlayerFilter = bgFiltersStore((state) => state.emptyPlayerFilter);
  const playerFilter = bgFiltersStore((state) => state.playerFilter);
  const filterDecades = bgStylesStore((state) => state.filterDecades);
  const filterAlphabets = bgStylesStore((state) => state.filterAlphabets);
  const setDecadeFilter = bgStylesStore((state) => state.setDecadeFilter);
  const setAlphabetFilter = bgStylesStore((state) => state.setAlphabetFilter);
  const setAllLanguageFilters = bgStylesStore((state) => state.setAllLanguageFilters);
  const setAllDecadeFilters = bgStylesStore((state) => state.setAllDecadeFilters);
  const setAllGenreFilters = bgStylesStore((state) => state.setAllGenreFilters);
  const setAllAlphabetFilters = bgStylesStore((state) => state.setAllAlphabetFilters);
  const isAllLanguageFiltersSet = bgStylesStore((state) => state.isAllLanguageFiltersSet);
  const isAllGenreFiltersSet = bgStylesStore((state) => state.isAllGenreFiltersSet);
  const isAllDecadeFiltersSet = bgStylesStore((state) => state.isAllDecadeFiltersSet);
  const isAllAlphabetFiltersSet = bgStylesStore((state) => state.isAllAlphabetFiltersSet);
  const getTracks = bgStylesStore((state) => state.getTracks);
  const getTracksMore = bgStylesStore((state) => state.getTracksMore);
  const tracks = bgStylesStore((state) => state.tracks);
  const totalCount = bgStylesStore((state) => state.totalCount);
  const isOrderBySongTitleSet = bgStylesStore((state) => state.isOrderBySongTitleSet);
  const isOrderByArtistNameSet = bgStylesStore((state) => state.isOrderByArtistNameSet);
  const isOrderByPopularitySet = bgStylesStore((state) => state.isOrderByPopularitySet);
  const setOrderBySongTitle = bgStylesStore((state) => state.setOrderBySongTitle);
  const setOrderByArtistName = bgStylesStore((state) => state.setOrderByArtistName);
  const setOrderByPopularity = bgStylesStore((state) => state.setOrderByPopularity);
  const isFinished = bgStylesStore((state) => state.isFinished);
  const isMusicSearchFiltersOn = navigationStore((state) => state.isMusicSearchFiltersOn);
  const isChangeable = bgStylesStore((state) => state.isChangeable);
  const setIsChangeable = bgStylesStore((state) => state.setIsChangeable);
  const setSettings = settingsStore((state) => state.setSettings);
  const setMusicLanguageFilter = musicStore((state) => state.setLanguageFilter);
  const setMusicGenreFilter = musicStore((state) => state.setGenreFilter);
  const setMusicDecadeFilter = musicStore((state) => state.setDecadeFilter);
  const setMusicAllLanguageFilters = musicStore((state) => state.setAllLanguageFilters);
  const setMusicAllDecadeFilters = musicStore((state) => state.setAllDecadeFilters);
  const setMusicAllGenreFilters = musicStore((state) => state.setAllGenreFilters);
  const setPaddingBottom = navigationStore((state) => state.setPaddingBottom);
  const getMusicTracks = musicStore((state) => state.getTracks);
  const singers = singersStore((state) => state.singers);
  const getSingers = singersStore((state) => state.getSingers);
  const filters = bgFiltersStore((state) => state.filters);
  const getFilters = bgFiltersStore((state) => state.getFilters);
  const saveFilter = bgFiltersStore((state) => state.saveFilter);
  const setCurrentFilter = bgFiltersStore((state) => state.setCurrentFilter);
  const currentFilter = bgFiltersStore((state) => state.currentFilter);
  const settings = settingsStore((state) => state.settings);
  const getSettings = settingsStore((state) => state.getSettings);
  const setLocalCurrentFilter = bgFiltersStore((state) => state.setLocalCurrentFilter);
  const deleteFilter = bgFiltersStore((state) => state.deleteFilter);
  const setError = messageStore((state) => state.setError);
  const setPlayerFilter = bgFiltersStore((state) => state.setPlayerFilter);
  const filterOutPlayQueue = bgPerformanceStore((state) => state.filterOutPlayQueue);
  const isBgPlayerInit = navigationStore((state) => state.isBgPlayerInit);
  const setMessage = messageStore((state) => state.setMessage);
  const setBgPlayerInit = navigationStore((state) => state.setBgPlayerInit);
  const settingsMusicStyleId = settingsStore((state) => state.settings?.music_style_id)

  const alphabets = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "Ã…", "Ã„", "Ã–", "#"];

  useEffect(() => {
    if (!environment) {
      getEnvironment(sessionToken);
    }
    if (!filters) {
      getFilters(sessionToken);
    }
    if (!singers) {
      getSingers(sessionToken);
    }
    if (!settings) {
      getSettings(sessionToken);
    }
  }, []);

  useEffect(() => {
    refreshUI();
  });

  useEffect(() => {
    console.log("playerFilter", "playerFilter");
    if (playerFilter && isBgPlayerInit) {
      setMessage(sessionToken, TR.cm_style_applied);
    }
  }, [settingsMusicStyleId]);

  const [anchorElLoad, setAnchorElLoad] = useState(null);
  const [anchorElSave, setAnchorElSave] = useState(null);
  const [isBackgroundMusicFilterLoadMenuOpen, setBackgroundMusicFilterLoadMenuOpen] = useState(false);
  const [isBackgroundMusicFilterSaveMenuOpen, setBackgroundMusicFilterSaveMenuOpen] = useState(false);

  const handleBackgroundMusicFilterLoadMenuClose = () => {
    setBackgroundMusicFilterLoadMenuOpen(false);
  };

  const handleOpenBackgroundMusicFilterLoadMenu = (event) => {
    setAnchorElLoad(event.currentTarget);
    setBackgroundMusicFilterLoadMenuOpen(true);
  };

  const handleBackgroundMusicFilterSaveMenuClose = () => {
    setBackgroundMusicFilterSaveMenuOpen(false);
  };

  const handleOpenBackgroundMusicFilterSaveMenu = (event) => {
    setAnchorElSave(event.currentTarget);
    setBackgroundMusicFilterSaveMenuOpen(true);
  };

  useEffect(() => {
    if (currentFilter) {
      //Muvika is the best
      console.log("currentFilter: " + JSON.stringify(currentFilter));
      let isAllLanguageFiltersSet = true;
      let isAllGenreFiltersSet = true;
      let isAllDecadeFiltersSet = true;
      Object.keys(currentFilter.filterLanguages).forEach((key) => {

        if (currentFilter.filterLanguages[key]) {
          isAllLanguageFiltersSet = false;
        }
      });
      Object.keys(currentFilter.filterGenres).forEach((key) => {

        if (currentFilter.filterGenres[key]) {
          isAllGenreFiltersSet = false;
        }
      });
      Object.keys(currentFilter.filterDecades).forEach((key) => {

        if (currentFilter.filterDecades[key]) {
          isAllDecadeFiltersSet = false;
        }
      });
      bgStylesStore.setState({
        isAllLanguageFiltersSet: isAllLanguageFiltersSet,
        isAllGenreFiltersSet: isAllGenreFiltersSet,
        isAllDecadeFiltersSet: isAllDecadeFiltersSet,
        isAllAlphabetFiltersSet: true,
        isOrderBySongTitleSet: true,
        isOrderByArtistNameSet: false,
        isOrderByPopularitySet: false,
        filterLanguages: currentFilter.filterLanguages,
        filterGenres: currentFilter.filterGenres,
        filterDecades: currentFilter.filterDecades,
        filterAlphabets: {},
      });
      getTracks(sessionToken, itemsOnPage);
      refreshUI();
      scrollToTop();
    }
  }, [currentFilter]);

  useEffect(() => {
    refreshUI();
  }, [tracks]);

  const [isBackgroundMusicFilterDeleteOpen, setBackgroundMusicFilterDeleteOpen] = useState(false);

  const handleBackgroundMusicFilterDeleteClose = () => {
    setBackgroundMusicFilterDeleteOpen(false);
  };

  const handleOpenBackgroundMusicFilterDelete = (event) => {
    setBackgroundMusicFilterDeleteOpen(true);
  };

  const [isSaveBackgroundMusicFilterOpen, setIsSaveBackgroundMusicFilterOpen] = useState(false);

  const handleOpenSaveBackgroundMusicFilter = () => {
    setIsSaveBackgroundMusicFilterOpen(true);
  };

  const handleCloseSaveBackgroundMusicFilter = () => {
    setIsSaveBackgroundMusicFilterOpen(false);
  };

  const handleSaveBackgroundMusicFilter = (filterName) => {
    if (filterName.length > 0) {
      let filter = {
        id: 0,
        name: filterName,
        filterLanguages: filterLanguages,
        filterGenres: filterGenres,
        filterDecades: filterDecades,
      };
      console.log(filter);
      saveFilter(sessionToken, filter);
      refreshUI();
      setIsChangeable(false);
      setIsSaveBackgroundMusicFilterOpen(false);
    } else {
      setError(sessionToken, 0, TR.cm_name_cannot_be_empty);
    }
  };

  const handleChange = () => {
    if (currentFilter && singers) {
      let filterToBeSaved = {
        id: currentFilter.id,
        name: currentFilter.name,
        isAllLanguageFiltersSet: isAllLanguageFiltersSet,
        isAllGenreFiltersSet: isAllGenreFiltersSet,
        isAllDecadeFiltersSet: isAllDecadeFiltersSet,
        filterLanguages: filterLanguages,
        filterGenres: filterGenres,
        filterDecades: filterDecades,
      };
      if (playerFilter) {
        if (playerFilter.id === currentFilter.id) {
          saveFilter(sessionToken, filterToBeSaved, true, singers[0]);
        } else {
          saveFilter(sessionToken, filterToBeSaved);
        }
      } else {
        saveFilter(sessionToken, filterToBeSaved);
      }
      setIsSaveBackgroundMusicFilterOpen(false);
      refreshUI();
      setIsChangeable(false);
    } else {
      handleOpenSaveBackgroundMusicFilter();
    }
  };

  const handleSetCurrentFilter = (filterId) => {
    if (settings) {
      setCurrentFilter(filterId);
      refreshUI();
      setIsChangeable(false);
    }
  };

  const handleSaveFilter = (filter) => {
    if (singers) {
      let filterToBeSaved = {
        id: filter.id,
        name: filter.name,
        isAllLanguageFiltersSet: isAllLanguageFiltersSet,
        isAllGenreFiltersSet: isAllGenreFiltersSet,
        isAllDecadeFiltersSet: isAllDecadeFiltersSet,
        filterLanguages: filterLanguages,
        filterGenres: filterGenres,
        filterDecades: filterDecades,
      };
      if (playerFilter) {
        if (playerFilter.id === filter.id) {
          saveFilter(sessionToken, filterToBeSaved, true, singers[0]);
        } else {
          saveFilter(sessionToken, filterToBeSaved);
        }
      } else {
        saveFilter(sessionToken, filterToBeSaved);
      }
      setIsChangeable(false);
      refreshUI();
    }
    setIsSaveBackgroundMusicFilterOpen(false);
  };

  const handleUseFilter = () => {
    if (currentFilter && singers) {
      let filterToBeSaved = {
        id: currentFilter.id,
        name: currentFilter.name,
        isAllLanguageFiltersSet: isAllLanguageFiltersSet,
        isAllGenreFiltersSet: isAllGenreFiltersSet,
        isAllDecadeFiltersSet: isAllDecadeFiltersSet,
        filterLanguages: filterLanguages,
        filterGenres: filterGenres,
        filterDecades: filterDecades,
      };
      setBgPlayerInit(true);
      saveFilter(sessionToken, filterToBeSaved, true, singers[0]);
      let newSettings = { ...settings };
      newSettings.music_style_id = currentFilter.id;
      setSettings(sessionToken, newSettings, false);
      setIsChangeable(false);
      refreshUI();
    }
  };

  useEffect(() => {
    console.log("isWaiting", isWaiting);
  }, [isWaiting]);

  const handleScrollDown = () => {
    if (tracks) {
      getTracksMore(sessionToken, itemsOnPage);
    }
  };

  const scrollToTop = () => {
    const element = document.getElementById('music-catalog-tracklist');
    if (element) {
      element.scrollTop = 0;
    }
    refreshUI();
  };

  const handleLanguageChange = (id, isSelected) => {
    setLanguageFilter(id, !isSelected);
    getTracks(sessionToken, itemsOnPage);
    scrollToTop();
    refreshUI();
    if (settings) {
      if (!settings.usage_mode || settings.usage_mode === "restaurant") {
        setIsChangeable(true);
      }
    }
  };

  const handleGenreChange = (id, isSelected) => {
    setGenreFilter(id, !isSelected);
    getTracks(sessionToken, itemsOnPage);
    scrollToTop();
    refreshUI();
    if (settings) {
      if (!settings.usage_mode || settings.usage_mode === "restaurant") {
        setIsChangeable(true);
      }
    }
  };

  const handleDecadeChange = (id, isSelected) => {
    setDecadeFilter(id, !isSelected);
    getTracks(sessionToken, itemsOnPage);
    scrollToTop();
    refreshUI();
    if (settings) {
      if (!settings.usage_mode || settings.usage_mode === "restaurant") {
        setIsChangeable(true);
      }
    }
  };

  const handleAlphabetChange = (id, isSelected) => {
    setAlphabetFilter(id, !isSelected);
    getTracks(sessionToken, itemsOnPage);
    scrollToTop();
    refreshUI();
    if (settings) {
      if (!settings.usage_mode || settings.usage_mode === "restaurant") {
        setIsChangeable(true);
      }
    }
  };

  const handleAllLanguagesChange = () => {
    if (environment) {
      setAllLanguageFilters(environment.track_languages);
      getTracks(sessionToken, itemsOnPage);
      scrollToTop();
      refreshUI();
      if (settings) {
        if (!settings.usage_mode || settings.usage_mode === "restaurant") {
          setIsChangeable(true);
        }
      }
    }
  };

  const handleAllGenresChange = () => {
    if (environment) {
      setAllGenreFilters(environment.genres);
      getTracks(sessionToken, itemsOnPage);
      scrollToTop();
      refreshUI();
      if (settings) {
        if (!settings.usage_mode || settings.usage_mode === "restaurant") {
          setIsChangeable(true);
        }
      }
    }
  };

  const handleAllDecadesChange = () => {
    setAllDecadeFilters(decades);
    getTracks(sessionToken, itemsOnPage);
    scrollToTop();
    refreshUI();
    if (settings) {
      if (!settings.usage_mode || settings.usage_mode === "restaurant") {
        setIsChangeable(true);
      }
    }
  };

  const handleAllAlphabetsChange = () => {
    setAllAlphabetFilters(alphabets);
    getTracks(sessionToken, itemsOnPage);
    scrollToTop();
    refreshUI();
    if (settings) {
      if (!settings.usage_mode || settings.usage_mode === "restaurant") {
        setIsChangeable(true);
      }
    }
  };

  const orderByArtistName = () => {
    setOrderByArtistName();
    getTracks(sessionToken, itemsOnPage);
    scrollToTop();
  };

  const orderBySongTitle = () => {
    setOrderBySongTitle();
    getTracks(sessionToken, itemsOnPage);
    scrollToTop();
  };

  const orderByPopularity = () => {
    setOrderByPopularity();
    getTracks(sessionToken, itemsOnPage);
    scrollToTop();
  };

  const handleFilterDelete = () => {
    if (currentFilter) {
      deleteFilter(sessionToken, currentFilter.id);
      if (playerFilter) {
        if (playerFilter.id === currentFilter.id) {
          emptyPlayerFilter();
          let newSettings = { ...settings };
          newSettings.music_style_id = 0;
          setSettings(sessionToken, newSettings, false);
        }
      }
    }
    handleBackgroundMusicFilterDeleteClose();
  };

  const handleSearchFilterChange = () => {
    toggleMusicSearchFilters();
    refreshUI();
  };

  const renderSearchFilters = () => {
    let cF = currentFilter;
    if (environment) {
      return <SearchFilters
        id="bg-filters"
        filters={filters}
        currentFilter={currentFilter}
        isBackgroundMusic={true}
        expanded={isMusicSearchFiltersOn}
        onSetCurrentFilter={handleSetCurrentFilter}
        onSaveFilter={handleSaveFilter}
        onOpenDeleteBackgroundMusicFilter={handleOpenBackgroundMusicFilterDelete}
        onOpenSaveBackgroundMusicFilter={handleOpenSaveBackgroundMusicFilter}
        onChange={handleSearchFilterChange}
        isOrderBySongTitleSet={isOrderBySongTitleSet}
        isOrderByArtistNameSet={isOrderByArtistNameSet}
        isOrderByPopularitySet={isOrderByPopularitySet}
        orderBySongTitle={orderBySongTitle}
        orderByArtistName={orderByArtistName}
        orderByPopularity={orderByPopularity}
        isAllLanguageFiltersSet={isAllLanguageFiltersSet}
        isAllGenreFiltersSet={isAllGenreFiltersSet}
        isAllDecadeFiltersSet={isAllDecadeFiltersSet}
        isAllAlphabetFiltersSet={isAllAlphabetFiltersSet}
        languages={environment.track_languages}
        filterLanguages={filterLanguages}
        genres={environment.genres}
        filterGenres={filterGenres}
        decades={decades}
        alphabets={alphabets}
        filterDecades={filterDecades}
        filterAlphabets={filterAlphabets}
        onAllLanguagesChange={handleAllLanguagesChange}
        onAllGenresChange={handleAllGenresChange}
        onAllDecadesChange={handleAllDecadesChange}
        onAllAlphabetsChange={handleAllAlphabetsChange}
        onLanguageChange={handleLanguageChange}
        onGenreChange={handleGenreChange}
        onDecadeChange={handleDecadeChange}
        onAlphabetChange={handleAlphabetChange}
      />;
    }
  };

  const renderExpandLessButton = () => {
    if (isMusicSearchFiltersOn) {
      return <IconButton onClick={() => {
        handleSearchFilterChange();
        refreshUI();
      }}>
        <ExpandLess />
      </IconButton>;
    }
  };

  const renderSaveCurrentButton = () => {
    if (settings) {
      if (!settings.usage_mode || settings.usage_mode === "restaurant") {
        if (isChangeable) {
          return <div className="muvika-save-div">
            <Button className="muvika-save-button" variant="text" color="success" onClick={
              handleChange
            }>{TR.cm_bg_save_current}
            </Button>
          </div>;
        }
      }
    }
  };

  const renderSaveButton = () => {
    if (settings) {
      if (!settings.usage_mode || settings.usage_mode === "restaurant") {
        return <Button color="success"
          aria-controls={isBackgroundMusicFilterSaveMenuOpen ? "menu-music-filter-save" : undefined}
          aria-haspopup="true"
          aria-expanded={isBackgroundMusicFilterSaveMenuOpen ? 'true' : undefined}
          onMouseDown={handleOpenBackgroundMusicFilterSaveMenu}>{TR.cm_save}</Button>;
      }
    }
  };

  const renderUseButton = () => {
    if (settings) {
      if (!settings.usage_mode || settings.usage_mode === "restaurant") {
        if (currentFilter) {
          return <Button
            color="success"
            onMouseDown={handleUseFilter}
          >{TR.cm_use}</Button>;
        }
      }
    }
  };

  const renderLoadButton = () => {
    if (filters) {
      if (filters.length > 0) {
        return <Button
          color="success"
          aria-controls={isBackgroundMusicFilterLoadMenuOpen ? "menu-music-filter-load" : undefined}
          aria-haspopup="true"
          aria-expanded={isBackgroundMusicFilterLoadMenuOpen ? 'true' : undefined}
          onMouseDown={handleOpenBackgroundMusicFilterLoadMenu}
        >{TR.cm_load}</Button>;
      }
    }
  };

  const renderDeleteButton = () => {
    if (settings) {
      if (!settings.usage_mode || settings.usage_mode === "restaurant") {
        if (currentFilter) {
          return <Button
            color="secondary"
            onMouseDown={handleOpenBackgroundMusicFilterDelete}
          >{TR.cm_delete}</Button>;
        }
      }
    }
  };

  const renderFilterName = () => {
    if (currentFilter) {
      return <h3 className="muvika-filter-name">{currentFilter.name}</h3>;
    }
  };

  const renderLoadSaveDelete = () => {
    if (currentFilter) {
      return <Grid item xs={12} justifyContent="right">
        <Stack direction="row" spacing={3} justifyContent="right">
          {renderSaveButton()}
          {renderLoadButton()}
          {renderUseButton()}
          {renderDeleteButton()}
        </Stack>
      </Grid>;
    } else {
      return <Grid item xs={12} justifyContent="right">
        <Stack direction="row" spacing={4} justifyContent="right">
          {renderSaveButton()}
          {renderLoadButton()}
          {renderDeleteButton()}
        </Stack>
      </Grid>;
    }
  };

  const renderFiltersSaveList = () => {
    if (filters) {
      return filters.map((filter, index) =>
        <MenuItem key={filter.id} onMouseDown={() => {
          setBackgroundMusicFilterSaveMenuOpen(false);
          handleSaveFilter(filter);
          setIsChangeable(false);
          setPaddingBottom("muvika-music-catalog", 0);
          setPaddingBottom("music-catalog-tracklist", 0);
        }}>
          {filter.name}
        </MenuItem>
      );
    }
  };

  const renderFiltersLoadList = () => {
    if (filters) {
      return filters.map((filter, index) =>
        <MenuItem key={filter.id} onMouseDown={() => {
          setCurrentFilter(filter.id);
          setIsChangeable(false);
          setPaddingBottom("muvika-music-catalog", 0);
          setPaddingBottom("music-catalog-tracklist", 0);
          setBackgroundMusicFilterLoadMenuOpen(false);
        }}>
          {filter.name}
        </MenuItem>
      );
    }
  };

  const refreshUI = () => {
    if (isChangeable) {
      if (settings) {
        if (!settings.usage_mode || settings.usage_mode === "restaurant") {
          setPaddingBottom("muvika-music-catalog", -30);
          setPaddingBottom("music-catalog-tracklist", -30);
        }
      }
    } else {
      setPaddingBottom("muvika-music-catalog", 0);
      setPaddingBottom("music-catalog-tracklist", 0);
    }
    window.dispatchEvent(new Event('resize'));
  };

  const handleScroll = (scrollTop, scrollHeight) => {
    if (tracks) {
      if (Math.abs(scrollTop - scrollHeight) <= 1) {
        getTracksMore(sessionToken, itemsOnPage);
        refreshUI();
        const element = document.getElementById('music-catalog-tracklist');
        if (element) {
          element.scrollTop = element.scrollHeight - element.clientHeight;
        }
      }
    }
  };

  const renderTotalCount = () => {
    if (tracks) {
      return <p className="muvika-music-catalog-total-text">{TR.cm_total}: {totalCount}</p>;
    }
  };

  const waitingRender = () => {
    if (isWaiting) {
      return <Waiting />;
    }
  };

  return (
    <div>
      <DeleteDialog
        openToLeft={true}
        open={isBackgroundMusicFilterDeleteOpen}
        onClose={handleBackgroundMusicFilterDeleteClose}
        onDeletion={handleFilterDelete}
        title={TR.cm_are_you_sure}
        cancel={TR.cm_cancel}
        delete={TR.cm_delete}
      />
      <SaveBackgroundMusicFilter
        open={isSaveBackgroundMusicFilterOpen}
        onClose={handleCloseSaveBackgroundMusicFilter}
        onFilterSave={handleSaveBackgroundMusicFilter}
      />
      <Grid container spacing={0}>
        <Grid item xs={11}>
          <h3>{TR.cm_bg_styles}</h3>
        </Grid>
        <Grid item xs={1}>
          {renderLoadSaveDelete()}
        </Grid>
      </Grid>
      {renderFilterName()}
      <ContentContainer id="muvika-music-catalog" onScroll={handleScroll} isFinished={true} isSongbook={false}>
        {renderSearchFilters()}
        <Grid container spacing={0}>
          <Grid item xs={11}>
            {renderTotalCount()}
          </Grid>
          <Grid item xs={1}>
            {renderExpandLessButton()}
          </Grid>
        </Grid>
        {/*  <TrackListScroller isCatalog={true} isBackgroundMusic={true} isWaiting={isWaiting} id="music-catalog-tracklist" tracks={tracks} onScrollDown={handleScrollDown} isFinished={isFinished} /> */}
        <List className="muvika-track-list-scroller-list">
          <TrackListContainer isBackgroundMusic={true} isSongbook={false} tracks={tracks} />
          {waitingRender()}
        </List>
      </ContentContainer>
      {renderSaveCurrentButton()}
      <Menu disableAutoFocus disableEnforceFocus disableRestoreFocus
        id={"menu-music-filter-load"}
        style={{ zIndex: 99999 }}
        open={isBackgroundMusicFilterLoadMenuOpen}
        anchorEl={anchorElLoad}
        onClose={handleBackgroundMusicFilterLoadMenuClose}
        MenuListProps={{
          'aria-labelledby': "menu-music-filter-load",
        }}
      >
        {renderFiltersLoadList()}
      </Menu>
      <Menu disableAutoFocus disableEnforceFocus disableRestoreFocus
        id={"menu-music-filter-save"}
        style={{ zIndex: 99999 }}
        open={isBackgroundMusicFilterSaveMenuOpen}
        anchorEl={anchorElSave}
        onClose={handleBackgroundMusicFilterSaveMenuClose}
        MenuListProps={{
          'aria-labelledby': "menu-music-filter-save",
        }}
      >
        <MenuItem onMouseDown={() => {
          handleBackgroundMusicFilterSaveMenuClose();
          handleOpenSaveBackgroundMusicFilter();
        }}>
          &raquo; {TR.cm_create_new_style}
        </MenuItem>
        {renderFiltersSaveList()}
      </Menu>
    </div>
  );
}

export default BgStyles;